import React, {useContext, useState } from 'react';  
import { Link, useLocation } from 'react-router-dom'; 
import { AuthContext } from '../../context/AuthContext'; 


export default function Header() {
  const location = useLocation();  
  const { isAuthenticated, userRole,logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for controlling hamburger menu
  const [showAlert, setShowAlert] = useState(true);  

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeAlert = () => {
    setShowAlert(false);
  };

   // Close the menu when clicking on a link (only applicable to mobile views)
   const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      {/* {isAuthenticated && showAlert && (
        <div style={{
          backgroundColor: 'red',
          color: 'white',
          textAlign: 'center',
          padding: '10px 0',
          fontSize: '14px',
          fontWeight: 'bold',
          position: 'relative',
          top: 0,
          width: '105%',
          zIndex: 1000
        }}>
          ⚠️ This website does not support web browser's dark mode.
          <button 
            onClick={closeAlert} 
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'bold',
              position: 'absolute',
              right: '25px',
              top: '5px',
              cursor: 'pointer'
            }}>
            ✖
          </button>
        </div>
      )} */}

    <header className="App-header">
      <nav>
        <div className="nav-container">
          <div className="hamburger" onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>


          <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
            <li className={location.pathname === "/" ? "active" : ""}>
              <Link to="/" onClick={handleLinkClick}>Home</Link>
            </li>


           <li className={location.pathname === "/dashboard" ? "active" : ""}>
              <Link to="/dashboard" onClick={handleLinkClick}>PrimeGear</Link>
            </li>

           {/* Cine - Only Accessible to Client A and Admin */}
            {(userRole === "clientA" || userRole === "admin") && (
                <li className={location.pathname === "/cine" ? "active" : ""}>
                    <Link to="/cine" onClick={handleLinkClick}>Cine</Link>
                </li>
            )}

            {userRole === "admin" && (

            <li className={location.pathname === "/admin" ? "active" : ""}>
                <Link to="/admin" onClick={handleLinkClick}>Admin Panel</Link>
              </li>
            )}

            <li className={location.pathname === "/About" ? "active" : ""}>
              <Link to="/About" onClick={handleLinkClick}>About</Link>
            </li>
            <li className={location.pathname === "/help" ? "active" : ""}>
              <Link to="/help" onClick={handleLinkClick}>Help</Link>
            </li>


{/*             
            <li className={location.pathname === "/admin" ? "active" : ""}>
                <Link to="/admin" onClick={handleLinkClick}>Admin Panel</Link>
              </li>
             */}
           
            <li className="support-creator-btn">
            {isAuthenticated && (
              <li>
                <button className="resume-button" onClick={() => { logout(); handleLinkClick(); }}>Logout</button>
              </li>
            )}
              <a href="https://www.paypal.com/donate/?hosted_button_id=P6S5KK4WHNBZS" target="_blank" rel="noopener noreferrer">
                <button className="support-button" onClick={toggleMenu}>Support the Creator</button>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    </>
  );
}
